let statusList = {
    new: {
        label: 'New',
        variant: 'primary',
        icon: 'fe-circle'

    },
    confirmed: {
        label: 'Confirmed',
        variant: 'info',
        icon: 'fe-check'
    },
    late: {
        label: 'Late',
        variant: 'warning',
        icon: 'fe-watch'
    },
    notConfirmed: {
        label: 'Not confirmed',
        variant: 'warning',
        icon: 'fe-alert-circle'

    },
    arrived: {
        label: 'Arrived',
        variant: 'warning',
        icon: 'fe-arrow-down-circle'
    },
    cancelled: {
        label: 'Cancelled',
        variant: 'danger',
        icon: 'fe-x-circle'
    },
    noshow: {
        label: 'No show',
        variant: 'danger',
        icon: 'fe-eye-off'
    },
    started: {
        label: 'Started',
        variant: 'success',
        icon: 'fe-play-circle'
    },
    completed: {
        label: 'Completed',
        variant: '',
        icon: 'fe-check-circle'
    },
};
export {
    statusList
};
export default function (status) {
    let statused;

    if (statusList[status]) {
        statused = statusList[status];
    } else {
        statused = {
            label: status
        }
    }

    return statused;
};
